import React from 'react'

function About() {

  return (
    <section className="m-5" >
      <div className='p-5'>
        <h1>About me</h1>
      </div>
      <div className="d-flex justify-content-center"> <p className='p-5 display-5'>
        My name is JunJie Wu. I am full stack engineer and looking a coding relative postion.
        I have my certificatie in full stack web development from Columbia University Bootcamp.
        I am excited to submit my application for opportunities within your company.
      </p></div>

    </section>
  )
}

export default About